<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_ix">INTRODUCTION</a></h2><a id="page_ix">
<p class="noindent">There’s only one thing better than Christmas movies, and that’s answering questions all about them. We therefore humbly present you with <em class="italic">Quiz Actually</em> – a title we totally thought up ourselves not related to any particular film or production. Oh, alright, you got us. But <em class="italic">Love Actually</em> is one of our favourite Chrimbo flicks, and you will be able to find questions about it on page 151.</p>
<p class="indent"><em class="italic">Quiz, Actually</em> comprises a mix of multiple-choice and straight-down-the-line questions; we like to mix it up around here. And, if that weren’t enough, there’s also all manner of challenges, forfeits, games, and fun activities – indeed, quite a lot of the time there’s no need to have even watched the movie in order to have a good old-fashioned Xmas mess-about LOLtime.</p>
</a><p class="indent"><a id="page_ix">The films are presented alphabetically – no favouritism here, despite what we just said above – and it’s entirely up to </a><a id="page_x">you whether you take it movie-by-movie and answer all the questions, or pick out the first three of different films, or just dive in and create whatever combination you feel inspired by.</a></p><a id="page_x">
<p class="indent">There’s enough here for the movie geeks to really go to town, as well as oodles of silliness – what better way could there be to tap into the season of good cheer?</p>
<p class="indent">Over to you …</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Introduction.vue?38fd8ac0